import Skeleton from "../../../MentorDashboardV2/UI/Skeleton";
import SprPageFrame from "../../ui/SprPageFrame";
import styles from "./style.module.css";

const TopicCardSkeleton = () => (
  <div className={styles.card}>
    <Skeleton.Row>
      <Skeleton variant="text" width="45%" height={28} />
      <Skeleton variant="text" width={220} height={28} className={styles.pushRight} />
    </Skeleton.Row>
    <Skeleton.Row>
      <Skeleton variant="rounded" width={90} height={28} />
      <Skeleton variant="text" width={150} height={16} />
      <Skeleton variant="text" width={170} height={16} />
    </Skeleton.Row>
    <Skeleton.Group>
      {[0, 1, 2].map((key) => (
        <Skeleton key={key} variant="rounded" width="100%" height={44} />
      ))}
    </Skeleton.Group>
    <Skeleton variant="rounded" width="100%" height={96} />
  </div>
);

const HeroSkeleton = () => (
  <div className={styles.hero}>
    <Skeleton variant="circular" width={160} height={160} />
    <Skeleton variant="text" width={320} height={56} />
    <Skeleton variant="text" width={180} height={20} />
    <div className={styles.stats}>
      {[0, 1, 2, 3].map((key) => (
        <Skeleton.Row key={key}>
          <Skeleton variant="circular" width={40} height={40} />
          <Skeleton.Group>
            <Skeleton variant="text" width={60} height={22} />
            <Skeleton variant="text" width={120} height={16} />
          </Skeleton.Group>
        </Skeleton.Row>
      ))}
    </div>
  </div>
);

/**
 * Shimmer for a whole report page, shaped like the real sections so the layout does
 * not jump when data lands: hero, two topic cards, four completed cards, badges.
 * Rendered inside `SprPageFrame`, so it uses the real column and the `--spr-*` tokens.
 */
const SprPageSkeleton = () => (
  <div aria-hidden="true" data-testid="spr-page-skeleton">
    <SprPageFrame hero={<HeroSkeleton />}>
      <div className={styles.section}>
        <Skeleton variant="text" width={420} height={40} />
        <TopicCardSkeleton />
        <TopicCardSkeleton />
      </div>

      <div className={styles.section}>
        <Skeleton variant="text" width={300} height={40} />
        <div className={styles.twoCol}>
          {[0, 1, 2, 3].map((key) => (
            <Skeleton key={key} variant="rounded" width="100%" height={112} />
          ))}
        </div>
      </div>

      <div className={styles.section}>
        <Skeleton variant="text" width={260} height={40} />
        <div className={styles.fourCol}>
          {[0, 1, 2, 3].map((key) => (
            <Skeleton key={key} variant="rounded" width="100%" height={80} />
          ))}
        </div>
      </div>
    </SprPageFrame>
  </div>
);

export default SprPageSkeleton;
